import React from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
  label: string;
  value: React.ReactNode;
  fullWidth?: boolean;
}

/** Read-only label/value pair for partner portal. */
const PartnerReadOnlyField: React.FC<Props> = ({ label, value, fullWidth }) => (
  <Box sx={{ minWidth: fullWidth ? '100%' : 140 }}>
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    <Typography variant="body2" component="div" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
      {value ?? '—'}
    </Typography>
  </Box>
);

export default PartnerReadOnlyField;
